export default __webpack_public_path__ + "static/media/reading.74262a35.png";